var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_2988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3234 4.68744H7.47697L7.36631 4.37531C6.91941 3.11469 5.72309 2.89269 5.625 2.83547V0L6.187 0.114094C8.21959 0.526656 9.79847 2.10122 10.2094 4.12544L10.3234 4.68744Z",
    fill: "#6AA9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 5.15619C2.8125 3.30375 4.67616 2.84353 4.6875 2.83547V0L4.1255 0.114094C1.73725 0.598844 0 2.69809 0 5.15619C0 6.57778 0.578281 7.86684 1.51194 8.8005L3.26562 8.37494L3.49975 6.81269C3.07534 6.38831 2.8125 5.80237 2.8125 5.15619Z",
    fill: "#FF641A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3234 5.625L10.2094 6.18688C9.72968 8.54938 7.63968 10.3125 5.15625 10.3125C3.73468 10.3125 2.44562 9.73438 1.51187 8.80062L3.49968 6.81281C3.92406 7.23719 4.51 7.5 5.15625 7.5C7.05281 7.5 7.43906 5.67844 7.47687 5.625H10.3234Z",
    fill: "#FFE470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3234 5.625L10.2094 6.18688C9.72969 8.54938 7.63969 10.3125 5.15625 10.3125V7.5C7.05281 7.5 7.43906 5.67844 7.47687 5.625H10.3234Z",
    fill: "#FFB64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 7.5625H15.0312V15.5312H12.2188V7.5625Z",
    fill: "#FFB64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 12.25H11.2812V15.5312H8.46875V12.25Z",
    fill: "#6AA9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71875 11.3125H7.53125V15.5312H4.71875V11.3125Z",
    fill: "#FFE470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.96875 13.1875H3.78125V15.5312H0.96875V13.1875Z",
    fill: "#FF641A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.0625H16V16H0V15.0625Z",
    fill: "#61729B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.0625H16V16H8V15.0625Z",
    fill: "#47568C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_2988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.7bf412e4ad7a10588489acb2b4ff827e.svg";
export { ForwardRef as ReactComponent };